// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BdVGEdkCaOA5hWAxz_gA{margin-bottom:4px}.BdVGEdkCaOA5hWAxz_gA a{justify-content:center;padding:28px 10px 20px;font-size:24px;display:flex}.BdVGEdkCaOA5hWAxz_gA .OZ2_FaAuDgMMtBtJFiHV{height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `BdVGEdkCaOA5hWAxz_gA`,
	"icon": `OZ2_FaAuDgMMtBtJFiHV`
};
export default ___CSS_LOADER_EXPORT___;
